import React from 'react';
import '../styles/LoadingAnimation.css';

const LoadingAnimation = ({ active }) => (
    <div className={`loading-overlay ${active ? 'active' : ''}`}>
      <div className="loading-spinner"></div>
    </div>
  );

export default LoadingAnimation;